import "./LegalNotice.scss";

import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ORGANIZATION } from "../../config/organization";

const LegalNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <main className="legalNoticePage">
      <h1 className="pageTitle">{t("legalNotice.title")}</h1>
      <p className="officialStatement">{t("legalNotice.officialSite")}</p>

      <section className="pageSection">
        <h2 className="sectionTitle">{t("legalNotice.publisherTitle")}</h2>
        <p className="sectionText">{t("legalNotice.publisherText")}</p>

        <dl className="identityList">
          <div className="identityRow">
            <dt>{t("legalNotice.legalNameLabel")}</dt>
            <dd>
              <strong>{ORGANIZATION.legalName}</strong>
            </dd>
          </div>
          <div className="identityRow">
            <dt>{t("legalNotice.legalFormLabel")}</dt>
            <dd>{t("legalNotice.legalFormValue")}</dd>
          </div>
          <div className="identityRow">
            <dt>{t("legalNotice.registeredOfficeLabel")}</dt>
            <dd>
              <address className="identityAddress">
                {ORGANIZATION.address.street}
                <br />
                {ORGANIZATION.address.postalCode} {ORGANIZATION.address.city}
                <br />
                {ORGANIZATION.address.country}
              </address>
            </dd>
          </div>
          <div className="identityRow">
            <dt>{t("legalNotice.companyNumberLabel")}</dt>
            <dd>{ORGANIZATION.companyNumber}</dd>
          </div>
          <div className="identityRow">
            <dt>{t("legalNotice.vatLabel")}</dt>
            <dd>{ORGANIZATION.vatNumber}</dd>
          </div>
          <div className="identityRow">
            <dt>{t("legalNotice.emailLabel")}</dt>
            <dd>
              <a className="pageLink" href={`mailto:${ORGANIZATION.email}`}>
                {ORGANIZATION.email}
              </a>
            </dd>
          </div>
          <div className="identityRow">
            <dt>{t("legalNotice.officialWebsiteLabel")}</dt>
            <dd>
              <a className="pageLink" href={ORGANIZATION.websiteUrl}>
                {ORGANIZATION.websiteUrl}
              </a>
            </dd>
          </div>
        </dl>
      </section>

      <section className="pageSection">
        <h2 className="sectionTitle">{t("legalNotice.contactTitle")}</h2>
        <p className="sectionText">{t("legalNotice.contactText")}</p>
        <p className="sectionText">
          <a className="pageLink" href={`mailto:${ORGANIZATION.email}`}>
            {ORGANIZATION.email}
          </a>
        </p>
      </section>

      <section className="pageSection">
        <h2 className="sectionTitle">{t("legalNotice.termsTitle")}</h2>
        <p className="sectionText">{t("legalNotice.termsText")}</p>
        <p className="sectionText">
          <Link className="pageLink" to="/terms">
            {t("legalNotice.termsLink")}
          </Link>
        </p>
        <p className="sectionText">
          <Link className="pageLink" to="/a-propos">
            {t("legalNotice.aboutLink")}
          </Link>
        </p>
      </section>
    </main>
  );
};

export default LegalNotice;
